import objectPath from 'object-path'
import {
  isExternalApiUrl,
  PRINT_PATH,
  ROUTE_API,
  ROUTE_HIS,
} from 'designer/component/action/Config'

const getRuleGoToUrlConfig = (action = {}) => {
  let actionType = action.state || action.type
  return (
    objectPath.get(action, actionType) ||
    action.config ||
    action.goToUrl ||
    action.goToPrint ||
    action
  )
}

const getRuleGoToUrlParamValue = (
  paramConfig = {},
  designContext = {},
  formData = {},
  datasourceValue = {},
) => {
  let allParams = designContext?.urlParams || {}
  let propType = paramConfig.propType || paramConfig.source || ''
  let { key, value, sourceKey } = paramConfig

  if (propType === 'datasource' || propType === 'datasources') {
    return objectPath.get(datasourceValue, `${sourceKey}.${key}`)
  }
  if (
    propType === 'urlParam' ||
    propType === 'pathParams' ||
    propType === 'queryParams'
  ) {
    return objectPath.get(allParams, key)
  }
  if (propType === 'input' || propType === 'formData') {
    return objectPath.get(formData, key)
  }
  if (propType === 'user') {
    return objectPath.get(designContext.user || {}, key)
  }

  return value
}

const replaceRuleGoToUrlPathParams = (
  url = '',
  pathParams = [],
  designContext = {},
  formData = {},
  datasourceValue = {},
) => {
  let nextUrl = url

  pathParams.forEach((paramConfig = {}) => {
    let paramValue = getRuleGoToUrlParamValue(
      paramConfig,
      designContext,
      formData,
      datasourceValue,
    )
    nextUrl = nextUrl.replace(`:${paramConfig.param}`, paramValue)
  })

  return nextUrl
}

const appendRuleGoToUrlQueryParams = (
  url = '',
  queryParams = [],
  designContext = {},
  formData = {},
  datasourceValue = {},
) => {
  let queryString = []

  queryParams.forEach((paramConfig = {}) => {
    let paramValue = getRuleGoToUrlParamValue(
      paramConfig,
      designContext,
      formData,
      datasourceValue,
    )
    if (paramValue !== null && paramValue !== undefined) {
      queryString.push(`${paramConfig.param}=${paramValue}`)
    }
  })

  if (queryString.length === 0) return url

  let connect = url.indexOf('?') > -1 ? '&' : '?'
  return url ? url + connect + queryString.join('&') : url
}

const getRuleGoToUrl = (config = {}) => {
  let {
    url = '',
    linkType = '',
    pagePath = '',
  } = config

  if (['internal', 'page', 'form', 'print', 'url'].includes(linkType)) {
    url = pagePath || url
  } else if (linkType === 'api') {
    let { apiType, service = '', endpoint = '', api = '' } = config
    url = apiType === 'internal' ? service + endpoint : api
  }
  if (linkType === 'print' && !url) {
    url = PRINT_PATH
  }

  return url
}

const applyRulePerspectiveRoute = (url = '', config = {}) => {
  let { linkType = '', perspectiveRoute = '' } = config
  if (!perspectiveRoute || linkType === 'url') return url

  let perspective = perspectiveRoute
  if (perspective.startsWith('/#')) {
    perspective = perspective.replace('/#', '')
  }
  if (perspective.startsWith('/')) {
    return `${perspective}${url}`
  }
  return `/${perspective}${url}`
}

const openRuleUrl = (url = '', config = {}) => {
  if (!url || typeof window === 'undefined') return

  let target = config.openNewTab ? '_blank' : '_self'
  if (config.linkType === 'api') {
    if (url.startsWith('/')) {
      window.open(ROUTE_API + url, target)
    } else {
      window.open(`${ROUTE_API}/${url}`, target)
    }
  } else if (isExternalApiUrl(config.linkType, url)) {
    window.open(url, target)
  } else if (url.startsWith('http')) {
    window.open(url, target)
  } else if (url.startsWith('/')) {
    window.open(ROUTE_HIS + url, target)
  } else {
    window.open(`${ROUTE_HIS}/${url}`, target)
  }
}

export const onRuleGoToUrl = (
  designContext = {},
  action = {},
  data = {},
) => {
  let config = getRuleGoToUrlConfig(action)
  let { jsonForm = {} } = designContext
  let formData = data.formData || jsonForm.formData || {}
  let datasourceValue = objectPath.get(designContext, '@datasource') || {}
  let url = getRuleGoToUrl(config)

  url = applyRulePerspectiveRoute(url, config)
  url = replaceRuleGoToUrlPathParams(
    url,
    config.pathParams || [],
    designContext,
    formData,
    datasourceValue,
  )
  url = appendRuleGoToUrlQueryParams(
    url,
    config.queryParams || [],
    designContext,
    formData,
    datasourceValue,
  )
  openRuleUrl(url, config)

  return url
}
